import { benefitsPage } from '@constants/images';
import { roles, tierObject } from '@constants/index';
import { RootState, Tier } from '@utils/types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Profile = () => {
  const { t: translate } = useTranslation();
  const { tier, externalId, fullName, segmentCode, segmentName, mobile } =
    useSelector((state: RootState) => state.user);

  const tierValue: Tier = tierObject[tier as keyof typeof tierObject];

  return (
    <div className="relative h-full w-full overflow-hidden bg-white p-4">
      <Link to="/dashboard">
        <img src={benefitsPage.header.backgrey} alt="back" />
      </Link>
      <div className="mt-3">
        <h2 className="font-frblack text-xl">Profile</h2>

        <div className="mt-3 flex flex-col gap-6">
          <div className="flex flex-col gap-1 text-xs">
            <h3 className="text-grey-reward">Dealer Id</h3>
            <p className="">{externalId}</p>
          </div>
          <div className="flex flex-col gap-1 text-xs">
            <h3 className="text-grey-reward">Dealer Name</h3>
            <p className="">{fullName}</p>
          </div>
          <div className="flex flex-col gap-1 text-xs">
            <h3 className="text-grey-reward">Category</h3>
            <p className="">
              {segmentCode === roles.nonVPP
                ? segmentName
                : translate(tierValue.title)}
            </p>
          </div>
          <div className="flex flex-col gap-1 text-xs">
            <h3 className="text-grey-reward">Contact Number</h3>
            <p className="">{mobile}</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-9 w-full px-4">
        <p className="text-sm text-grey-reward">
          To make any changes contact{' '}
          <span className="text-black underline">+91 22 6212 5000</span>
        </p>
      </div>
    </div>
  );
};

export default Profile;
